<template>
  <div class="quiz_term">
    <span v-if="limited_flag === 1">公開終了 {{dateTime}}</span>
  </div>
</template>

<script>
import Util from '@/modules/Util'

export default {
  name: 'QuizTerm',
  props: {
    limited_flag: {
      type: Number,
      required: true
    },
    timestamp: {
      type: String,
      required: true
    }
  },
  computed: {
    dateTime () {
      return Util.getDateTime(this.timestamp)
    }
  }
}
</script>

<style scoped>
  .quiz_term {
    width: 800px;
    height: 60px;
    text-align: right;
  }

  .quiz_term > span {
    font-size: 16px;
    color: #878787;
    position: relative;
    top: 30px;
  }

  @media screen and (max-width: 767px) {
    .quiz_term > span {
      top: 0;
    }
  }

</style>
